import React, { useEffect, useRef } from 'react'

const ChatbotWidget = ({ isOpen, onClose, chatbotUrl, onToggle, buttonColor = "#1A202C", buttonTextColor = "#ffffff", buttonText = "Chat with us" }) => {
	const modalRef = useRef(null)

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (modalRef.current && !modalRef.current.contains(event.target)) {
				onClose()
			}
		}

		const handleEscapeKey = (event) => {
			if (event.key === 'Escape') {
				onClose()
			}
		}

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside)
			document.addEventListener('keydown', handleEscapeKey)
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
			document.removeEventListener('keydown', handleEscapeKey)
		}
	}, [isOpen, onClose])

	const adjustSize = () => {
		const modal = modalRef.current
		if (!modal) return

		if (window.innerWidth <= 480) {
			modal.style.right = '10px'
			modal.style.bottom = '80px'
			modal.style.width = '85vw'
			modal.style.height = '70vh'
		} else {
			modal.style.right = '20px'
			modal.style.bottom = '90px'
			modal.style.width = '360px'
			modal.style.height = '520px'
		}
	}

	useEffect(() => {
		adjustSize()
		window.addEventListener('resize', adjustSize)
		return () => window.removeEventListener('resize', adjustSize)
	}, [])

	return (
		<>
			<style>
				{`
          .chatbot-modal {
            container-type: inline-size;
            position: fixed;
            background: white;
            border-radius: 8px 8px 0px 8px;
            overflow: hidden;
            box-shadow: 0 8px 24px rgba(0,0,0,0.2);
            z-index: 2147483646;
            opacity: 0;
            transform: translateY(10px);
            transition: opacity 0.3s ease, transform 0.3s ease;
          }
          .chatbot-modal.open {
            opacity: 1;
            transform: translateY(0);
          }
          .chatbot-close-btn {
            position: absolute;
            top: 12px;
            right: 12px;
            z-index: 2147483647;
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: #777;
          }
          .chatbot-iframe {
            width: 100%;
            height: 100%;
            border: none;
          }
          .chatbot-toggle-btn {
            position: fixed;
            right: 20px;
            bottom: 20px;
            padding: 12px 20px;
            border-radius: 25px;
            background-color: ${buttonColor};
            color: ${buttonTextColor};
            border: none;
            cursor: pointer;
            font-size: 14px;
            font-weight: 500;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            z-index: 2147483645;
            display: flex;
            align-items: center;
            gap: 8px;
            font-family: sans-serif;
            min-width: 140px;
            justify-content: center;
          }
          .chatbot-toggle-btn svg path {
            stroke: ${buttonTextColor};
          }
        `}
			</style>

			{/* Chatbot Toggle Button - visible when closed */}
			<button
				className="chatbot-toggle-btn"
				onClick={onToggle}
				title={buttonText}
			>
				<svg width="24" height="24" viewBox="0 0 24 24" style={{ minWidth: '24px' }} fill="none">
					<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
					<path d="M8 12H8.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M12 12H12.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M16 12H16.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
				{buttonText}
			</button>

			{/* Chatbot Modal - visible when open */}
			{isOpen && (
				<div
					ref={modalRef}
					className={`chatbot-modal ${isOpen ? 'open' : ''}`}
					style={{
						right: window.innerWidth <= 480 ? '10px' : '20px',
						bottom: window.innerWidth <= 480 ? '80px' : '90px',
						width: window.innerWidth <= 480 ? '85vw' : '360px',
						height: window.innerWidth <= 480 ? '70vh' : '520px',
					}}
				>
					<button className="chatbot-close-btn" onClick={onClose}>
						&times;
					</button>
					<iframe src={chatbotUrl} className="chatbot-iframe" frameBorder="0" allowFullScreen={true} />
				</div>
			)}
		</>
	)
}

export default ChatbotWidget
